import React, { useEffect, useState } from "react";
import { addSr } from "../../../../src/assets";
import Contactus from "../../../sellers_module/components/dialog/contactus_dialog";
import { toast, ToastContainer } from "react-toastify";
import { captureGAEvent, gaPanelConfig } from "../../shared/helper";

export default function PartnerBanner() {
  const [isTabletView, setIsTabletView] = useState<boolean>(false);
  const [error, setError] = useState<string>("");

  useEffect(() => {
    const checkScreenSize = () => {
      setIsTabletView(window.innerWidth <= 1024); // Example: Consider width <= 1024 as tablet view
    };

    // Call checkScreenSize once to determine initial view
    checkScreenSize();

    // Add event listener to check screen size on resize
    window.addEventListener("resize", checkScreenSize);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);
  const [dialogOpen, setDialogOpen] = useState(false); // State to manage the dialog open/close

  const handleOpenDialog = () => {
    gaPanelConfig.BtnText = "contact_us";
    sendGAEvent("sras_contact_us")
    setDialogOpen(true); // Open the dialog when the button is clicked
  };
  const sendGAEvent = (event: string) => {
    captureGAEvent("sras_page_view ", event);
  };
  const handleCloseDialog = () => {
    setDialogOpen(false); // Close the dialog when needed
  };
  const handleContactusError = (errorMessage) => {
    setError(errorMessage);
    toast.error(errorMessage); // Show toast notification for the error
  };

  return (
    <>
      <div>
        <ToastContainer style={{ paddingTop: "50px" }} />{" "}
        {isTabletView ? (
          <>
            <div style={{ marginTop: "20px" }}>
              <div className="container relative" style={{ padding: "20px", }}>
                <img
                  src={addSr}
                  alt="App World"
                  style={{
                    height: "20vh",
                    borderRadius: "25px",
                  }}
                />
                <div className="absolute left-0 right-0 top-0 bottom-0 flex flex-col justify-center items-center z-10">
                  <div
                    className="container"
                    style={{
                      background: "none",
                      paddingTop: "20px",
                      paddingLeft: "20px",
                      paddingRight: "20px",
                      color: "#FFFFFF",
                      textAlign: "center",
                      fontSize: "20px",
                      fontFamily: "sfprobold",
                    }}
                  >
                    {"Do you want to list your app with Shiprocket App Store?"}
                  </div>
                  <button
                    onClick={handleOpenDialog}
                    style={{
                      marginTop: "10px",
                      background: "rgb(255, 255, 255)",
                      color: "#000000",
                      textAlign: "center",
                      fontSize: "15px",
                      fontFamily: "sfpromedium",
                      padding: "10px",
                      borderRadius: "10px",
                    }}
                  >
                    {"Contact Us"}
                  </button>
                  <Contactus
                    open={dialogOpen}
                    onClose={handleCloseDialog}
                    onError={handleContactusError} // Pass error handler
                    viewType={"tab"}
                  />
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            {/* First div - Hide on mobile view */}
            <div style={{ marginTop: "54px" }} className="hidden md:block">
              <div className="container">
                <div className="w-full relative">
                  <div
                    style={{ maxHeight: "150px" }}
                    className="absolute top-1/2 transform -translate-y-1/2 left-20 "
                  >
                    <div
                      className="container"
                      style={{
                        width: "500px",
                        background: "none",
                        opacity: 1,

                        color: "#FFFFFF",
                        textAlign: "start",
                        fontSize: "30px",
                        fontFamily: "sfprobold",
                        padding: "10px",
                      }}
                    >
                      {"Do you want to list your app with Shiprocket App Store?"}
                    </div>
                  </div>
                  <div className="absolute top-1/2 transform -translate-y-1/2 right-20 z-11">
                    <button
                      onClick={handleOpenDialog}
                      style={{
                        background: "rgb(255, 255, 255)",
                        opacity: 1,
                        height: "64px",
                        width: "200px",
                        color: "#000000",
                        textAlign: "center",
                        fontSize: "17px",
                        fontFamily: "sfpromedium",
                        padding: "10px",
                        borderRadius: "10px",
                      }}
                    >
                      {"Contact Us"}
                    </button>
                    <Contactus
                      open={dialogOpen}
                      onClose={handleCloseDialog}
                      onError={handleContactusError} // Pass error handler
                      viewType={"web"}

                    />
                  </div>
                  <img
                    src={addSr}
                    alt="App World"
                    style={{
                      width: "100%",
                      height: "100%",
                      maxHeight: "150px", // Limit the height to 350px
                      aspectRatio: "auto", // Maintain aspect ratio
                      borderRadius: "25px",
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Second div - Show on mobile view */}
            <div className="block md:hidden m-5" style={{ marginTop: "20px" }}>
              <div >
                {/* Content of the second div */}
                <div className="container relative">
                  <img
                    src={addSr}
                    alt="App World"
                    style={{
                      height: "20vh",
                      borderRadius: "25px",
                    }}
                  />
                  <div className="absolute left-0 right-0 top-0 bottom-0 flex flex-col justify-center items-center z-10">
                    <div
                      className="container"
                      style={{
                        background: "none",
                        paddingTop: "20px",
                        paddingLeft: "20px",
                        paddingRight: "20px",
                        color: "#FFFFFF",
                        textAlign: "center",
                        fontSize: "20px",
                        fontFamily: "sfprobold",
                      }}
                    >
                      {"Do you want to list your app with Shiprocket App Store?"}
                    </div>
                    <button
                      onClick={handleOpenDialog}
                      style={{
                        marginTop: "10px",
                        background: "rgb(255, 255, 255)",
                        color: "#000000",
                        textAlign: "center",
                        fontSize: "15px",
                        fontFamily: "sfpromedium",
                        padding: "10px",
                        borderRadius: "10px",
                      }}
                    >
                      {"Contact Us"}
                    </button>
                    <Contactus
                      open={dialogOpen}
                      onClose={handleCloseDialog}
                      onError={handleContactusError} // Pass error handler
                      viewType={"mob"}
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}
